<template>
  <svg class="discount-tags__icon-remove">
    <path d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round"></path>
  </svg>
</template>